module.exports = __webpack_public_path__ + "img/2012-12-14 20.00.24.862a51e5.jpg";